import { useEffect } from 'react';

import { FirebaseService, httpService } from '@flexo/general';
import { useDispatch, useSelector } from 'react-redux';
import { METADATA, USER, ALERT } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;
const firebaseService = new FirebaseService();

export const MembersResolver = () => {
  
  const dispatch = useDispatch();

  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1]; 
  const params = useParams();
  const metadata = useSelector((state: any) => state.metadata);

  async function init() {

    const idToken = await firebaseService.getIdToken();

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED'
        },
      } as any));

      // setUserStore({
      //   type: UserTypes.SetUserLogOut,
      //   payload: {
      //     value: true,
      //   }
      // })

      dispatch(USER.SetLogout());

      return;
    }

    const COMMUNITY_ID = pathSegment === 'community' ? params.id : null;

    if (!COMMUNITY_ID) {
      return;
    }
   
    dispatch(METADATA.SetMembersAsync({idToken, dispatch, COMMUNITY_ID}) as any);

    // try {
      
    // globalSetFiltersStore({
    //   type: FiltersStoreTypes.SetFilteredMembers,
    //   payload: {
    //     value: members
    //   }
    // })
    // } catch (err: any) {
    //   console.warn(err);
    // }
  }

  useEffect(() => {
      init();
  }, [params.id]);

  return <></>;
};
